import { Query } from '@/_core/cqrs/types/queries';

export class NewWorkspaceQuery extends Query<NewWorkspaceQueryResult> {
    constructor() {
        super('NewWorkspaceQuery');
    }
}

export interface NewWorkspaceQueryResult {
    PeopleName: string;
    UserName: string;
}
